import React, { useEffect, useRef, useState } from 'react'
import { KTIcon, KTSVG } from '../../../_metronic/helpers';
import { DateRangePicker } from 'rsuite';
import 'rsuite/dist/rsuite.css';
import moment from "moment";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import '../../../common/rsuite-datepicker.css';
import Select, { StylesConfig } from 'react-select';
import fetchAPI from '../../../common/fetchAPI';
import { ShowSwal } from '../../../common/SweetAlert';
import { dropDownSelectionStyles, getValueFromResource } from '../../../common/timeLiveFunction';
import DatePickerRanges from '../../../common/DatePickerRanges';
import Loader from '../../../common/Loader';
import { CSVLink } from 'react-csv';




const AttachmentArchivesFilter = (props: any) => {
    const { t, selectedModule, oncloseModal } = props;
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const { maxMenuHeight } = useAppSelector(state => state.globalState);
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useAppDispatch();
    const [EmployeeNameArray, setEmployeeNameArray] = useState<any | ''>([]);
    const [selectedEmployeeNameOptionDropDown, setSelectedEmployeeNameOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'All' });

    const [projectArray, setProjectArray] = useState<any | ''>([]);
    const [selectedProjectOptionDropDown, setSelectedProjectOptionDropDown] = useState<{ [object: string]: any }>({ value: '-1', label: 'All' });



    useEffect(() => {
        getEmployeeNameAsync();
        getProjectsByAccountAsync();
    }, [])

    const getEmployeeNameAsync = async () => {
        const response = await fetchAPI("api/V2/Employees/EmployeesViewByAccountIdWithDisabled", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountEmployeeId;
            item.label = item.EmployeeNameWithCodeWithDisabled;
            delete item.EmployeeNameWithCodeWithDisabled;
            delete item.AccountEmployeeId;

        });
        json.Data.unshift({ value: '-1', label: 'All' })

        setEmployeeNameArray(json.Data);
    }
    const getProjectsByAccountAsync = async () => {
        const response = await fetchAPI("api/V2/Projects/ProjectsByAccount", "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const json = await response.json();
        json.Data.map((item: any) => {
            item.value = item.AccountProjectId;
            item.label = item.ProjectName;
            delete item.AccountProjectId;
            delete item.ProjectName;

        });
        json.Data.unshift({ value: '-1', label: 'All' })
        setProjectArray(json.Data);
    }

    const handleDateRangeChange = (value: any) => {
        setStartDate(value[0]);
        setEndDate(value[1]);
    };

    const handleEmployeeNameChange = (data: any) => {
        const { value, label } = data;
        setSelectedEmployeeNameOptionDropDown({ value: value, label: label });
    };

    const handleProjectChange = (data: any) => {
        const { value, label } = data;
        setSelectedProjectOptionDropDown({ value: value, label: label });
    };


    const handleApplyFilterOnClickEvent = () => {
       setIsLoading(true);
        let SearchParamsValues = `${selectedModule?.value},${selectedEmployeeNameOptionDropDown.value},${selectedProjectOptionDropDown.value},${moment(startDate).format('MM-DD-YYYY')},${moment(endDate).format('MM-DD-YYYY')}`;
        getAttachmentArchiveAsync(SearchParamsValues);
    };

const convertToCSV = (data: any[]) => {
    if (!data || data.length === 0) return "";

    const keys = Object.keys(data[0]);
    const csvRows = [];
    csvRows.push(keys.join(","));
    for (const row of data) {
        const values = keys.map(k => {
            let val = row[k] ?? "";
            val = val.toString().replace(/"/g, '""');
            return `"${val}"`;
        });
        csvRows.push(values.join(","));
    }

    return csvRows.join("\n");
};



    const getAttachmentArchiveAsync = async (SearchParamsValues: any) => {
        const response = await fetchAPI("api/v2/AttachmentArchive/DownloadAttachments/" + SearchParamsValues, "GET", "", true, "0df3ab0c-4033-4013-8b1e-2f0b64f8cbab");
        const contentType = response.headers.get("content-type");
        if (contentType && contentType.includes("application/zip")) {
            const nblob = await response.blob();
            setIsLoading(false);
            if (nblob.size > 0) {
                
                const url = window.URL.createObjectURL(nblob);
                const link = document.createElement('a');
                link.href = url;
                if (selectedModule?.value === "-1") {
                    link.setAttribute('download', 'Timesheet Attachments.zip');
                }
                else {
                    link.setAttribute('download', 'Expense Attachments.zip');
                }
                document.body.appendChild(link);
                link.click();
                setIsLoading(false);
                oncloseModal();
                ShowSwal('Attachment', 'Attachment(s) downloaded successfully.', 'success');
            }
            else {
                ShowSwal('Attachment', 'No attachment found.', 'error');
            }

        } else {
            const res = await response.json();
            if (res && res.count > 0) {
                const csvString = convertToCSV(res.data);
                const blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });

                const url = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = url;
                link.setAttribute("download", "Skipped-Attachments-Log.csv");
                document.body.appendChild(link);
                link.click();
                setIsLoading(false);
            }
        }
        setIsLoading(false);


    }
    const handleResetFiltersOnClickEvent = () => {
        setStartDate(new Date());
        setEndDate(new Date());
        setSelectedEmployeeNameOptionDropDown({ value: '-1', label: 'All' });
        setSelectedProjectOptionDropDown({ value: '-1', label: 'All' });



    };


    return (
        <>

            <div className="modal drawer-overlay" style={{ display: 'block' }}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        {isLoading && (
                            <div className="modal-loader-overlay d-flex justify-content-center align-items-center">
                                <Loader/>
                                {/* <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div> */}
                            </div>
                        )}

                        <div className="modal-header" style={{ padding: '.6rem .6rem' }}>
                            <h5 className="modal-title mainHeading">
                                {/* {t(`Download ${selectedModule.label} Attachments`)} */}
                                {getValueFromResource(`Download ${selectedModule.label} Attachments`,dispatch, t)}

                                </h5>
                            <div className="btn btn-icon btn-sm btn-active-secondary ms-2 "
                                onClick={oncloseModal}
                            >
                                <KTSVG path="/media/icons/duotune/arrows/arr061.svg" className="svg-icon svg-icon-1x" />
                            </div>
                        </div>
                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="fs-7 fw-normal mb-2">
                                    {/* {t('Date Range')} */}
                                    {getValueFromResource('Date Range',dispatch, t)}
                                    </label>
                                <div>
                                    <DateRangePicker
                                        onChange={handleDateRangeChange}
                                        ranges={DatePickerRanges() }
                                        value={[startDate, endDate]}
                                        placeholder='Please Select Date Range'
                                        cleanable={false}
                                        ></DateRangePicker>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <label className="fs-7 fw-normal mb-2">
                                    {/* {t('Employee')} */}
                                    {getValueFromResource('Employee',dispatch, t)}

                                    </label>
                                <Select
                                    value={selectedEmployeeNameOptionDropDown}
                                    className="basic-single"
                                    classNamePrefix="select"
                                    isSearchable={true}
                                    name="StatusList"
                                    onChange={handleEmployeeNameChange}
                                    options={EmployeeNameArray}
                                    styles={dropDownSelectionStyles}
                                    maxMenuHeight={maxMenuHeight}
                                />
                            </div>
                            {selectedModule?.value !== "-1" ? (
                                <div className='mb-3'>
                                    <label className="fs-7 fs-7 fw-normal mb-2">
                                        {/* {t('Project')} */}
                                        {getValueFromResource('Project',dispatch, t)}
                                        </label>
                                    <Select
                                        value={selectedProjectOptionDropDown}
                                        className="basic-single"
                                        classNamePrefix="select"
                                        isSearchable={true}
                                        name="ProjectList"
                                        onChange={handleProjectChange}
                                        options={projectArray}
                                        styles={dropDownSelectionStyles}
                                        maxMenuHeight={maxMenuHeight}
                                    />
                                </div>
                            ) : null}



                        </div>
                        <div className="modal-footer" style={{ padding: '.6rem .6rem' }} >
                            <button
                                type="button"
                                className="btn btn-secondary btn-bs-btn-font-weight btn-sm"
                                onClick={handleResetFiltersOnClickEvent}                                
                            >
                                {/* {t('Reset Filters')} */}
                                {getValueFromResource('Reset Filters',dispatch, t)}

                            </button>
                            <button type="button" className="btn btn-primary  btn-bs-btn-font-weight btn-sm" onClick={handleApplyFilterOnClickEvent}>
                                {/* {t('Download')} */}
                                {getValueFromResource('Download',dispatch, t)}

                            </button>
                        </div>
                    </div>
                </div>
            </div>


        </>

    )

}


export default AttachmentArchivesFilter